import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => (
  <footer className="mt-32 border-t border-border" data-testid="site-footer">
    <div className="mx-auto max-w-6xl px-6 py-14 sm:px-10">
      <div className="flex flex-col gap-10 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="font-mono-label mb-3">Available for new work</p>
          <h3 className="max-w-md text-2xl font-bold leading-snug sm:text-3xl">
            Have something in mind?
            <Link
              to="/contact"
              data-testid="footer-contact-link"
              className="ml-2 inline-flex items-center text-[#FF4D00] hover:underline"
            >
              Start a conversation
              <ArrowUpRight size={22} />
            </Link>
          </h3>
        </div>
        <div className="font-mono-label space-y-1 sm:text-right">
          <p>John Doe — Web Developer</p>
          <p>United States · Remote</p>
          <p>© {new Date().getFullYear()}</p>
        </div>
      </div>
    </div>
  </footer>
);
